import { Product } from '../types';

// ============================================
// HEAD LIGHT RELAY WIRING HARNESS
// ============================================

// HEAD LIGHT WIRING WITHOUT RELAY
export const headlightWiringWithoutRelayProducts: Product[] = [
  {
    id: "headlight-wiring-standard",
    name: "Universal Head Light Relay Wiring - Without Relay",
    slug: "headlight-wiring-without-relay-standard",
    category: "Wiring Harness",
    subcategory: "Head Light Wiring Without Relay",
    description: "Universal head light relay wiring harness without relay. Complete wiring kit for headlight upgrade. Made with premium quality wire.",
    partNumber: "SI2100",
    images: ["/products/headlight-wiring/withoutrelay/SI2100.jpg"],
    featured: true,
    specifications: {
      "Type": "Head Light Relay Wiring",
      "Relay": "Without Relay",
      "Holder Type": "Standard",
      "Fuse": "Included",
      "Application": "Universal",
    },
    tags: ["headlight", "wiring", "harness", "without-relay", "universal"],
    applications: ["Universal Vehicles", "Headlight Upgrade", "Automotive"],
  },
  {
    id: "headlight-wiring-bakelite",
    name: "Universal Head Light Wiring - Without Relay, Bakelite Holder",
    slug: "headlight-wiring-without-relay-bakelite",
    category: "Wiring Harness",
    subcategory: "Head Light Wiring Without Relay",
    description: "Universal head light relay wiring without relay. Features bakelite holder for durability and heat resistance.",
    partNumber: "SI2101",
    images: ["/products/headlight-wiring/withoutrelay/SI2101.jpg"],
    featured: true,
    specifications: {
      "Type": "Head Light Relay Wiring",
      "Relay": "Without Relay",
      "Holder Type": "Bakelite",
      "Fuse": "Included",
      "Application": "Universal",
    },
    tags: ["headlight", "wiring", "without-relay", "bakelite", "universal"],
    applications: ["Universal Vehicles", "Headlight Upgrade"],
  },
  {
    id: "headlight-wiring-extra-long",
    name: "Universal Head Light Wiring - Without Relay, Extra Long Wire",
    slug: "headlight-wiring-without-relay-extra-long",
    category: "Wiring Harness",
    subcategory: "Head Light Wiring Without Relay",
    description: "Universal head light relay wiring without relay. Extra long wire for commercial vehicles and trucks.",
    partNumber: "SI2103",
    images: ["/products/headlight-wiring/withoutrelay/SI2103.jpg"],
    specifications: {
      "Type": "Head Light Relay Wiring",
      "Relay": "Without Relay",
      "Wire Length": "Extra Long",
      "Fuse": "Included",
      "Application": "Universal",
    },
    tags: ["headlight", "wiring", "without-relay", "extra-long", "commercial"],
    applications: ["Commercial Vehicles", "Trucks", "Long Wire Routing"],
  },
  {
    id: "headlight-wiring-60a-fuse",
    name: "Universal Head Light Wiring - Without Relay, 60 AMPS Single Fuse",
    slug: "headlight-wiring-without-relay-60a-fuse",
    category: "Wiring Harness",
    subcategory: "Head Light Wiring Without Relay",
    description: "Universal head light relay wiring without relay. Features 60 AMPS single fuse for heavy duty applications.",
    partNumber: "SI2106",
    images: ["/products/headlight-wiring/withoutrelay/SI2106.jpg"],
    featured: true,
    specifications: {
      "Type": "Head Light Relay Wiring",
      "Relay": "Without Relay",
      "Fuse": "60 AMPS Single Fuse",
      "Application": "Universal",
    },
    tags: ["headlight", "wiring", "without-relay", "60-amps", "heavy-duty"],
    applications: ["Commercial Vehicles", "Heavy Duty Headlights"],
  },
  {
    id: "headlight-wiring-no-fuse-bakelite",
    name: "Universal Head Light Wiring - Without Relay, Without Fuse, Bakelite",
    slug: "headlight-wiring-without-relay-no-fuse-bakelite",
    category: "Wiring Harness",
    subcategory: "Head Light Wiring Without Relay",
    description: "Universal head light wiring without relay and without fuse. Bakelite holder. For vehicles with existing fuse protection.",
    partNumber: "SI2107",
    images: ["/products/headlight-wiring/withoutrelay/SI2107.jpg"],
    specifications: {
      "Type": "Head Light Relay Wiring",
      "Relay": "Without Relay",
      "Holder Type": "Bakelite",
      "Fuse": "Without Fuse",
      "Application": "Universal",
    },
    tags: ["headlight", "wiring", "without-relay", "no-fuse", "bakelite"],
    applications: ["Vehicles with Existing Fuse Protection"],
  },
  {
    id: "headlight-wiring-no-fuse",
    name: "Universal Head Light Wiring - Without Relay, Without Fuse",
    slug: "headlight-wiring-without-relay-no-fuse",
    category: "Wiring Harness",
    subcategory: "Head Light Wiring Without Relay",
    description: "Universal head light wiring without relay and without fuse. Basic wiring harness.",
    partNumber: "SI2108",
    images: ["/products/headlight-wiring/withoutrelay/SI2108.jpg"],
    specifications: {
      "Type": "Head Light Relay Wiring",
      "Relay": "Without Relay",
      "Fuse": "Without Fuse",
      "Application": "Universal",
    },
    tags: ["headlight", "wiring", "without-relay", "no-fuse", "basic"],
    applications: ["Basic Headlight Wiring"],
  },
  {
    id: "headlight-wiring-h1-h7",
    name: "Universal Head Light Wiring - Without Relay, H1/H7 Holder",
    slug: "headlight-wiring-without-relay-h1-h7",
    category: "Wiring Harness",
    subcategory: "Head Light Wiring Without Relay",
    description: "Universal head light wiring without relay. Compatible with H1/H7 bulb holders.",
    partNumber: "SI2109",
    images: ["/products/headlight-wiring/withoutrelay/SI2109.jpg"],
    specifications: {
      "Type": "Head Light Relay Wiring",
      "Relay": "Without Relay",
      "Holder Type": "H1/H7 Holder",
      "Fuse": "Included",
      "Application": "Universal",
    },
    tags: ["headlight", "wiring", "without-relay", "h1", "h7", "holder"],
    applications: ["H1/H7 Headlight Bulbs", "Modern Vehicles"],
  },
  {
    id: "headlight-wiring-ace-4fuse-ceramic",
    name: "Universal Head Light Wiring - Without Relay, 4 ACE Fuse Ceramic",
    slug: "headlight-wiring-without-relay-4-ace-fuse-ceramic",
    category: "Wiring Harness",
    subcategory: "Head Light Wiring Without Relay",
    description: "Universal head light wiring without relay. Features 4 ACE fuse with ceramic gity holder.",
    partNumber: "SI2110",
    images: ["/products/headlight-wiring/withoutrelay/SI2110.jpg"],
    specifications: {
      "Type": "Head Light Relay Wiring",
      "Relay": "Without Relay",
      "Holder Type": "Ceramic Gity",
      "Fuse": "4 ACE Fuse",
      "Application": "Universal",
    },
    tags: ["headlight", "wiring", "without-relay", "ace-fuse", "ceramic"],
    applications: ["Tata ACE", "Universal Vehicles"],
  },
];

// HEAD LIGHT WIRING WITH RELAY
export const headlightWiringWithRelayProducts: Product[] = [
  {
    id: "headlight-wiring-relay-standard",
    name: "Universal Head Light Relay Wiring - With 12V Relay",
    slug: "headlight-wiring-with-relay-standard",
    category: "Wiring Harness",
    subcategory: "Head Light Wiring With Relay",
    description: "Universal head light relay wiring harness with 12V relay included. Complete plug-and-play kit for headlight upgrade with relay switching.",
    partNumber: "SI2100R",
    images: ["/products/headlight-wiring/withrelay/SI2100R.jpg"],
    featured: true,
    specifications: {
      "Type": "Head Light Relay Wiring",
      "Relay": "With 12V Relay",
      "Holder Type": "Standard",
      "Fuse": "Included",
      "Application": "Universal",
      "Voltage": "12V",
    },
    tags: ["headlight", "wiring", "harness", "with-relay", "12v", "universal"],
    applications: ["Universal Vehicles", "Headlight Upgrade", "Relay Switching"],
  },
  {
    id: "headlight-wiring-relay-bakelite",
    name: "Universal Head Light Wiring - With 12V Relay, Bakelite Holder",
    slug: "headlight-wiring-with-relay-bakelite",
    category: "Wiring Harness",
    subcategory: "Head Light Wiring With Relay",
    description: "Universal head light relay wiring with 12V relay. Features bakelite holder for superior heat resistance.",
    partNumber: "SI2101R",
    images: ["/products/headlight-wiring/withrelay/SI2101R.jpg"],
    featured: true,
    specifications: {
      "Type": "Head Light Relay Wiring",
      "Relay": "With 12V Relay",
      "Holder Type": "Bakelite",
      "Fuse": "Included",
      "Application": "Universal",
      "Voltage": "12V",
    },
    tags: ["headlight", "wiring", "with-relay", "bakelite", "12v", "universal"],
    applications: ["Universal Vehicles", "Headlight Upgrade"],
  },
  {
    id: "headlight-wiring-relay-extra-long",
    name: "Universal Head Light Wiring - With 12V Relay, Extra Long Wire",
    slug: "headlight-wiring-with-relay-extra-long",
    category: "Wiring Harness",
    subcategory: "Head Light Wiring With Relay",
    description: "Universal head light relay wiring with 12V relay. Extra long wire for commercial vehicles and trucks.",
    partNumber: "SI2103R",
    images: ["/products/headlight-wiring/withrelay/SI2103R.jpg"],
    specifications: {
      "Type": "Head Light Relay Wiring",
      "Relay": "With 12V Relay",
      "Wire Length": "Extra Long",
      "Fuse": "Included",
      "Application": "Universal",
      "Voltage": "12V",
    },
    tags: ["headlight", "wiring", "with-relay", "extra-long", "12v", "commercial"],
    applications: ["Commercial Vehicles", "Trucks", "Long Wire Routing"],
  },
  {
    id: "headlight-wiring-relay-60a-fuse",
    name: "Universal Head Light Wiring - With 12V Relay, 60 AMPS Single Fuse",
    slug: "headlight-wiring-with-relay-60a-fuse",
    category: "Wiring Harness",
    subcategory: "Head Light Wiring With Relay",
    description: "Universal head light relay wiring with 12V relay. Features 60 AMPS single fuse for heavy duty applications.",
    partNumber: "SI2106R",
    images: ["/products/headlight-wiring/withrelay/SI2106R.jpg"],
    featured: true,
    specifications: {
      "Type": "Head Light Relay Wiring",
      "Relay": "With 12V Relay",
      "Fuse": "60 AMPS Single Fuse",
      "Application": "Universal",
      "Voltage": "12V",
    },
    tags: ["headlight", "wiring", "with-relay", "60-amps", "heavy-duty", "12v"],
    applications: ["Commercial Vehicles", "Heavy Duty Headlights"],
  },
  {
    id: "headlight-wiring-relay-no-fuse-bakelite",
    name: "Universal Head Light Wiring - With 12V Relay, Without Fuse, Bakelite",
    slug: "headlight-wiring-with-relay-no-fuse-bakelite",
    category: "Wiring Harness",
    subcategory: "Head Light Wiring With Relay",
    description: "Universal head light wiring with 12V relay and bakelite holder, without fuse. For vehicles with existing fuse protection.",
    partNumber: "SI2107R",
    images: ["/products/headlight-wiring/withrelay/SI2107R.jpg"],
    specifications: {
      "Type": "Head Light Relay Wiring",
      "Relay": "With 12V Relay",
      "Holder Type": "Bakelite",
      "Fuse": "Without Fuse",
      "Application": "Universal",
      "Voltage": "12V",
    },
    tags: ["headlight", "wiring", "with-relay", "no-fuse", "bakelite", "12v"],
    applications: ["Vehicles with Existing Fuse Protection"],
  },
  {
    id: "headlight-wiring-relay-no-fuse",
    name: "Universal Head Light Wiring - With 12V Relay, Without Fuse",
    slug: "headlight-wiring-with-relay-no-fuse",
    category: "Wiring Harness",
    subcategory: "Head Light Wiring With Relay",
    description: "Universal head light wiring with 12V relay, without fuse. Basic relay wiring harness.",
    partNumber: "SI2108R",
    images: ["/products/headlight-wiring/withrelay/SI2108R.jpg"],
    specifications: {
      "Type": "Head Light Relay Wiring",
      "Relay": "With 12V Relay",
      "Fuse": "Without Fuse",
      "Application": "Universal",
      "Voltage": "12V",
    },
    tags: ["headlight", "wiring", "with-relay", "no-fuse", "12v"],
    applications: ["Basic Headlight Relay Wiring"],
  },
  {
    id: "headlight-wiring-relay-h1-h7",
    name: "Universal Head Light Wiring - With 12V Relay, H1/H7 Holder",
    slug: "headlight-wiring-with-relay-h1-h7",
    category: "Wiring Harness",
    subcategory: "Head Light Wiring With Relay",
    description: "Universal head light wiring with 12V relay. Compatible with H1/H7 bulb holders.",
    partNumber: "SI2109R",
    images: ["/products/headlight-wiring/withrelay/SI2109R.jpg"],
    featured: true,
    specifications: {
      "Type": "Head Light Relay Wiring",
      "Relay": "With 12V Relay",
      "Holder Type": "H1/H7 Holder",
      "Fuse": "Included",
      "Application": "Universal",
      "Voltage": "12V",
    },
    tags: ["headlight", "wiring", "with-relay", "h1", "h7", "holder", "12v"],
    applications: ["H1/H7 Headlight Bulbs", "Modern Vehicles"],
  },
  {
    id: "headlight-wiring-relay-ace-4fuse-ceramic",
    name: "Universal Head Light Wiring - With 12V Relay, 4 ACE Fuse Ceramic",
    slug: "headlight-wiring-with-relay-4-ace-fuse-ceramic",
    category: "Wiring Harness",
    subcategory: "Head Light Wiring With Relay",
    description: "Universal head light wiring with 12V relay. Features 4 ACE fuse with ceramic gity holder.",
    partNumber: "SI2110R",
    images: ["/products/headlight-wiring/withrelay/SI2110R.jpg"],
    featured: true,
    specifications: {
      "Type": "Head Light Relay Wiring",
      "Relay": "With 12V Relay",
      "Holder Type": "Ceramic Gity",
      "Fuse": "4 ACE Fuse",
      "Application": "Universal",
      "Voltage": "12V",
    },
    tags: ["headlight", "wiring", "with-relay", "ace-fuse", "ceramic", "12v"],
    applications: ["Tata ACE", "Universal Vehicles"],
  },
];
